import { gql } from '@apollo/client/core';

export const getBillingAccounts = gql`
  query BillingAccounts($where: BillingAccountWhereInput!) {
    billingAccounts(where: $where) {
      id
      name
      cif
      countryCode
      city
      zipCode
      excludeVAT
      fiscalAddress
      singleInvoice
      Contacts {
        id
        email
      }
      Contracts {
        id
      }
    }
  }
`;
